import { Link } from 'react-router-dom';
import getActiveInactiveStatus from '@product-framework/utils/getActiveInactiveStatus';

function locationName(original, props, accessorFunctionsAdditional) {
  return (
    <Link to={accessorFunctionsAdditional.navigate(original.id)}>
      {original?.locationName || ''}
    </Link>
  );
}

function locationNumber(original) {
  return original?.locationNumber || '';
}

function isDefaultLocation(original) {
  return original?.isDefaultLocation ? 'Yes' : 'No';
}

function status(original) {
  return getActiveInactiveStatus(original?.status);
}

export { locationName, locationNumber, isDefaultLocation, status };
